
export const routes = {
    home: '/',
    studies: '/studies',
    templates: '/templates',
    automessages: '/automessages',
    accounts:'/accounts',
    bounces:'/bounces',
    login: '/login'
}